import React from 'react';
import Badge from '../DataTableFields/Badge';

const BooleanFieldMarketing = ({ value, data, ...props }) => (
  <div
    className={value !== '-' && value === '1' ? 'master-yes' : 'master-no'}
    {...props}
  >
    <Badge>{value !== '-' && value === '1' ? 'Si' : 'No'}</Badge>
  </div>
);

export default BooleanFieldMarketing;
